import { useEffect, useState } from 'react';

import Bowser from 'bowser';

export const isBrowserOutdated = () => {
  if (!window.navigator.userAgent) return false;
  const browser = Bowser.getParser(window.navigator.userAgent);
  return !!browser?.satisfies({
    edge: '<79',
    ie: '<=11',
  });
};

const useBrowserOutdated = () => {
  const [isOutdated, setIsOutdated] = useState(false);

  useEffect(() => {
    setIsOutdated(isBrowserOutdated());
  }, [setIsOutdated]);

  return isOutdated;
};

export default useBrowserOutdated;
